/**
 * Hausrat Endkundenrechner-API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum HausratSchadenart {

    Feuer = 'Feuer',

    Einbruchdiebstahl = 'Einbruchdiebstahl',

    Leitungswasser = 'Leitungswasser',

    Sturm = 'Sturm',

    Elementar = 'Elementar',

    Starkregen = 'Starkregen',

    Glas = 'Glas',

    Fahrraddiebstahl = 'Fahrraddiebstahl'
}

